import React from "react";
import PropTypes from "prop-types";
import Card from "../card/Card";
import List from "../list/List";
import ListItem from "../list-item/ListItem";
import formatPhoneNumber from "../Helper/HelperFunctions";

const SellingDealer = (props) => {
    const { direction, sellingDealerData } = props;

    const displayData = () => {
        if (sellingDealerData) {

            return (
                <div className="card-container">
                    <Card cardTitle="Selling Dealer" cardIcon="fas fa-home">
                        <div className={`d-flex pl-31 flex-wrap flex-${direction}`}>
                            <List>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Dealer Name" itemValue={sellingDealerData.name} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Dealer Address" itemValue={sellingDealerData.address1} />
                                    <ListItem itemValue={sellingDealerData.address2} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="City" itemValue={sellingDealerData.city} />
                                </div>
                                <div className="card-col__1 mt-11 d-flex">
                                    <div className="w-100">
                                        <ListItem itemKey="State" itemValue={sellingDealerData.state} />
                                    </div>
                                    <div className="w-100">
                                        <ListItem itemKey="Zip/Postal Code" itemValue={sellingDealerData.zipCode} />
                                    </div>
                                </div>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Phone" itemValue={formatPhoneNumber(sellingDealerData.phoneNumber)} />
                                </div>
                            </List>
                        </div>
                    </Card>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

SellingDealer.propTypes = {
    direction: PropTypes.string,
    sellingDealerData: PropTypes.object
}

export default SellingDealer;